import React, { createContext, useContext, useRef } from 'react';
import { useSocket } from '../hooks';
const SocketContext = createContext(null);
export const useSocketContext = () => {
    const value = useContext(SocketContext);
    if (!value) {
        throw new Error('useSocketContext must be used within a SocketContextProvider');
    }
    return value;
};
export const SocketProvider = (props) => {
    const socket = useSocket();
    const connectionUsersCount = useRef(0);
    return (React.createElement(SocketContext.Provider, { value: { socket, connectionUsersCount } }, props.children));
};
//# sourceMappingURL=SocketContext.js.map